/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Picker_Select_VehicleInputs */

const vi_trip_picker_select_vehicle = /** @type {(inputs: Trip_Picker_Select_VehicleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn xe vận chuyển`)
};

/**

* @param {Trip_Picker_Select_VehicleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_picker_select_vehicle = /** @type {((inputs?: Trip_Picker_Select_VehicleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Picker_Select_VehicleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_picker_select_vehicle(inputs)
});